import { useMemo } from 'react';

import {
  getTaskStatusConfig,
  projectStatusByCode,
  isOwner,
  FullTask,
  loaders,
  actions,
} from 'entities';

import { Row } from 'components/Blocks';

import { TagSelect } from '../../TagSelect';

import { useTaskModal } from '../context.taskModal';

import { useUser } from 'hooks';
import { listGet } from 'utils/array';

export function TaskTags() {
  const loggedUser = useUser();

  const { task, updateTask, project } = useTaskModal();

  const { data } = loaders.teams.serviceTags.use({
    defaultValue: [],

    params: { serviceId: task.service },

    blockLoad: !isOwner(task, loggedUser),
  });

  const addTag = actions.projects.addTagToTask.use({
    onSuccess: (_, { tag }) => {
      updateTask((old) => ({
        ...old,
        tags: [...old.tags, { tag: listGet(data, tag) }] as FullTask['tags'],
      }));
    },
  });

  const removeTag = actions.projects.removeTagFromTask.use({
    onSuccess: (_, { tag }) => {
      updateTask((old) => ({
        ...old,
        tags: old.tags.filter((t) => t.tag.id !== tag),
      }));
    },
  });

  const taskTags = task.tags.map(({ tag }) => tag);

  const statusConfig = useMemo(() => getTaskStatusConfig(task.status), [task.status]);

  const taskRef = {
    project: task.projectId,
    task: task.id,
  };

  const canAddTag = [
    isOwner(task, loggedUser),
    !statusConfig.blocks.fullBlock,
    projectStatusByCode[project.status]?.isActiveStatus,
  ].every(Boolean);

  if (!taskTags.length && !canAddTag) return null;

  return (
    <Row flexWrap="wrap">
      <TagSelect
        showAddButton={canAddTag}
        tagOptions={data}
        tags={taskTags}
        onTagClick={(tag) => addTag.execute({ ...taskRef, tag: tag.id })}
        deleteTag={(tag) => removeTag.execute({ ...taskRef, tag })}
        tagClassName="min-h-4"
      />
    </Row>
  );
}
